/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-title[_ngcontent-%COMP%]{margin:20px 20px 20px 0;display:flex;justify-content:center}.modal-content[_ngcontent-%COMP%]{margin:50px;max-width:120vh;display:flex;justify-content:center;text-align:center}.modal-footer[_ngcontent-%COMP%]{margin:0 20px 20px}.hint[_ngcontent-%COMP%]{display:flex;justify-content:space-between;margin-bottom:20px}"];
export { styles as styles };
